module.exports = __webpack_public_path__ + "static/media/counter3464.d2fe559d.jpg";